import React from "react";

import CarClassCellContent from "../components/CarClassCellContent";

import base from "./base";

import { Column, ColumnId } from ".";

function carClass({ width, language, onResize }: Column.Options) {
	return base(
		ColumnId.CarClass,
		(item) => <CarClassCellContent item={item} language={language} />,
		{
			width,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default carClass;
